// Modules
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import uuid from "react-uuid";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdCoSgApi, AdCoCatApi, AdCoApi, AdCoUploadApi  } from "_Route/Api";
import { uploadPlugin } from "Admin/Component/AdFunc";
import DefaultCKEditor from "Admin/Component/DefaultCKEditor";

const AdConferenceDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // State
  const curType = params.id === 'add' ? '등록' : '수정'; // 관리 Type
  const curScore = params.id === 'add' ? 200 : 300;
  const useGroup = ['미사용', '사용']; // 사용 여부 배열

  const sessionID = localStorage.getItem('memSessionID')
  const imgHost = process.env.REACT_APP_IMG_HOST;
  const userName = useSelector(state => state.authorityAcc.name);
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);

  const [catList, setCatList] = useState([]);
  const [catValue, setCatValue] = useState();
  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm'); // 현재 날짜 및 시간
  
  const [info, setInfo] = useState({ // 전체 Input Data 배열 
    conference_use: 1,
    conference_title: '',
    conference_content: undefined,
    conference_category: '2',
    conference_cat: '',
    conference_create_user: userName,
    conference_file: undefined,
    conference_dfile: undefined,
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const [fileName, setFileName] = useState([]); // 추가된 모든 Image Array
  const { conference_use, conference_title, conference_content, conference_category, conference_cat } = info;


  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  // onChange Info
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }

  // onChange Info - Image URL
  const onChangeFile = () => {
    let fnFileArr = [] // 마지막 남은 Image Array
    fileName.map(list => {
      if (conference_content.includes(list)) {
        fnFileArr.push(list)
      }
    })
    // 삭제된 Image Array
    const dfile = fileName.filter(it => !fnFileArr.includes(it))

    setInfo({
      ...info,
      conference_file: fnFileArr.length !== 0 ? fnFileArr : undefined,
      conference_dfile: dfile.length !== 0 ? dfile : undefined,
    })
  }


  /*========================================================================
  * Set Current Conference List
  ========================================================================*/
  useEffect(() => {
    axios.get(AdCoCatApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      setCatList(res.data.result)
    })
    .catch(err => {
      console.error(err, "GET Category List Error...");
    })

    axios.get(AdCoSgApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        conference_uuid: params.id
      }
    })
    .then(res => {
      const curCo = res.data.result[0]
      if(curCo === undefined && params.id !== 'add') {
        navigate('/404');
      }
      
      if(curType === '수정') {
        setCatValue(curCo.conference_category);

        if(curCo.conference_file) {
          setFileName(JSON.parse(curCo.conference_file));
        }
      }
      setInfo({
        conference_use: curType === '수정' ? curCo.conference_use : 1,
        conference_title: curType === '수정' ? curCo.conference_title : '',
        conference_content: curType === '수정' ? curCo.conference_content : undefined,
        conference_category: curType === '수정' ? curCo.conference_category : '2',
        conference_cat: '',
        conference_create_user: userName,
        conference_last_modify_user: userName,
        conference_file: curType === '수정' && curCo.conference_file ? JSON.parse(curCo.conference_file) : undefined,
        conference_dfile: undefined,
        approve_spec_status: 0,
        approve_ap_status: 0,
      })
    })
    .catch(err => {
      console.error(err, "GET Conference Data Error...");
    })
  }, [location])


  /*========================================================================
  * Conference Axios 
  ========================================================================*/
  const CoConfirm = () => {
    if (conference_category === '1' && conference_cat === '') { alert("사용할 카테고리명을 입력해주세요.") }
    else if (conference_title === '') { alert("제목을 입력해주세요.") }
    else if (conference_content === '') { alert("내용을 입력해주세요.") }
    else {
      if (curType === '수정') { updateCO() }
      else { postCO() }
    }
  }
  
  const postCO = () => { // Conference 등록
    axios({
      url: AdCoApi,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      alert(`Conference 등록${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/conference/list')
    })
    .catch(err => {
      // alert(err.response.data.result)
      console.error(err, `Conference POST Error..`)
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const updateCO = () => { // Conference 수정
    const tempInfo = info;
    tempInfo.conference_uuid = params.id

    axios({
      url: AdCoApi,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: tempInfo
    })
    .then(res => {
      alert(`Conference 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/conference/list')
    })
    .catch(err => {
      console.error(err, "Conference PUT Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const deleteCO = () => { // Conference 삭제
    axios({
      url: AdCoApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        conference_uuid: params.id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`Conference 삭제${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/conference/list')
    })
    .catch(err => {
      console.error(err, "Conference DELETE Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>Conference {curType}</h2>
        <p>Home / Conference / Conference {curType}</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>Conference 글 수정</legend>

          {/* 사용여부 [conference_use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" name="conference_use" id={`conference_use_${i}`} value={i} onChange={(e) => onChange(e)} checked={Number(conference_use) === i}/>
                  <label htmlFor={`conference_use_${i}`}></label>

                  <label htmlFor={`conference_use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 카테고리 [conference_category] */}
          <div className="fieldGroup row">
            <label>카테고리<span className="redTxt">*</span></label>

            <div className="field gap">
              
              <select className="select md round_10 type_1" name="conference_category" onChange={(e) => {onChange(e); setCatValue(e.target.value)}} key={uuid()} defaultValue={curType === '등록' ? conference_category : catValue}>
                {catList.map((list, i) =>
                  <option value={list.confcat_no} key={i}>{list.conference_cat}</option>
                )}
              </select>
              
              { conference_category === "1" &&
                <input type="text" className="input md round_10" name="conference_cat" onChange={(e) => onChange(e)} value={conference_cat} placeholder="사용할 카테고리를 입력해주세요." />
              }
            </div>
          </div>

          {/* 제목 [conference_title] */}
          <div className="fieldGroup row">
            <label>제목<span className="redTxt">*</span></label>

            <div className="field full">
              <input type="text" className="input md round_10" name="conference_title" onChange={(e) => onChange(e)} value={conference_title} placeholder="제목을 입력해주세요." />
            </div>
          </div>

          {/* 내용 [conference_content] */}
          <div className="fieldGroup row">
            <label>내용<span className="redTxt">*</span></label>

            <div className="field full">
              <DefaultCKEditor
                config={{placeholder: "내용을 입력하세요."}}
                data={conference_content}
                onReady={(editor) => {
                  uploadPlugin(editor, AdCoUploadApi, setFileName)
                }}
                onChange={(event, editor) => {
                  {(conference_content || conference_content === "" || curType === "등록") &&
                  setInfo({
                    ...info,
                    conference_content: editor.getData()
                  })}
                }}
                onBlur={() => onChangeFile()}
              />
            </div>
          </div>

          {/* 작성/수정자 */}
          <div className="fieldGroup row">
            <label>{curType}자</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={userName} disabled />
            </div>
          </div>

          {/* 작성/수정 일시 */}
          <div className="fieldGroup row">
            <label>{curType} 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={() => CoConfirm()}>{curType} {master === 1 ? '' : '요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/conference/list')}>취소</button>
          {curType === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 게시물을 삭제하시겠습니까?`)) deleteCO() }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdConferenceDt;